import { Stack, Typography } from '@mui/material';

// Single label/value line shared by the e-mail marketing stat widgets.
export default function StatRow({ label, value, valueColor }) {
  return (
    <Stack direction='row' alignItems='baseline' justifyContent='space-between' spacing={1}>
      <Typography variant='body2' color='text.secondary' sx={{ minWidth: 0 }}>
        {label}
      </Typography>
      <Typography
        variant='body1'
        sx={{ fontWeight: 700, whiteSpace: 'nowrap', color: valueColor || 'text.primary' }}
      >
        {value}
      </Typography>
    </Stack>
  );
}
